import _filter from 'lodash.filter'
import _orderBy from 'lodash.orderby'
import axios from 'plugins/axios'
import search from 'mixins/search'

export const state = {
  list: [],
  filter: {
    name: '',
    category: null
  },
  order: [
    {
      name: 'newest',
      field: 'created_at',
      direction: 'desc'
    }
  ]
}

export const getters = {
  products (state) {
    return _filter(state.list, product => product.visible)
  },
  filteredProducts (state, getters) {
    let products = getters.products

    // filter products by category
    if (state.filter.category) {
      products = products.filter(product => product.categories.data && !!product.categories.data.find(productCategory => productCategory.id === state.filter.category))
    }

    // filter products by searchstring
    if (state.filter.name.length > 0) {
      products = _filter(products, product => {
        return search(state.filter.name, [
          product.name
        ])
      })
    }

    // create a new virtual property that contains the price for sorting
    products = products.map(p => ({
      ...p,
      sorting_price: p.use_discount_price ? p.default_discount_price : p.default_price
    }))

    return _orderBy(products, state.order.map(item => item.field), state.order.map(item => item.direction))
  },
  countProducts (state) {
    return state.list.length
  },
  countFilteredProducts (state, getters) {
    return getters.filteredProducts.length
  },
  allSelected (state) {
    if (!state.list.length) return false
    return state.list.reduce((acc, product) => acc && product.isSelected, true)
  },
  hasSelected (state) {
    if (!state.list.length) return false
    return state.list.reduce((acc, product) => acc || product.isSelected, false)
  },
  filterName (state) {
    return state.filter.name
  },
  filterCategory (state) {
    return state.filter.category
  },
  order (state) {
    return state.order[0]
  },
  getProductById: (state, getters) => (id) => {
    if (state.list.length === 0) return null
    return state.list.find(product => product.id === id)
  },
  getVariationForProduct: (state, getters) => (productId, variationId) => {
    let product = getters.getProductById(productId)
    if (!product || !product.variations) return null

    return product.variations.data.find(variation => variation.id === variationId)
  }
}

export const mutations = {
  add (state, product) {
    let oldProduct = state.list.find(p => p.id === product.id)

    if (oldProduct) {
      return state.list.splice(state.list.indexOf(oldProduct), 1, product)
    }

    return state.list.push({
      ...product,
      isSelected: false
    })
  },
  replace (state, product) {
    let oldProduct = state.list.find(p => p.id === product.id)

    state.list.splice(state.list.indexOf(oldProduct), 1, {
      ...product,
      isSelected: oldProduct.isSelected
    })
  },
  setFilterName (state, search) {
    state.filter.name = search
  },
  setFilterCategory (state, category) {
    state.filter.category = category || undefined
  },
  setOrder (state, order) {
    state.order = [order]
  },
  refreshStock (state, stockUpdateObject) {
    let oldProduct = state.list.find(p => p.id === stockUpdateObject.id)

    oldProduct.stock = stockUpdateObject.stock
    oldProduct.use_stock = stockUpdateObject.use_stock
  }
}

export const actions = {
  async request ({state, commit}) {
    if (state.list.length) return

    let {data} = await axios.get('/product')
    data.data.forEach(product => commit('add', product))
  },

  async requestDetailed ({commit}, id) {
    let {data} = await axios.get(`/product/${id}?include=variations,options`)
    commit('add', data.data)
  },

  async refreshStock ({commit}, id) {
    let {data} = await axios.get(`/product/${id}/stock`)
    commit('refreshStock', data.data)
  },

  setFilterCategory ({commit}, category) {
    commit('setFilterCategory', category)
  }
}



// WEBPACK FOOTER //
// ./client/store/products.js